import React,{Component} from 'react';
import Select from 'react-select';


class SelectInput extends Component {
  render(){
    return (
      <div>
        <Select 
          options={[]} 
          placeholder={this.props.placeholder} 
        />
      </div>
    )
  }
}

export default SelectInput;




// WEBPACK FOOTER //
// ./src/shared/components/SelectInput/index.js